module.exports = __webpack_public_path__ + "static/cad-designs4-9cb2aa0282380ad379a2b7d5242bca8a.png";